const routes = {
  root: '/staRedirect',
}

export default routes
